var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardVisa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44 32",
    "aria-label": "Visa Card",
    role: "img",
    focusable: "false",
    style: {
      display: "block",
      height: 33,
      width: 33
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#122D98",
    d: "M28.408 17.811c.006-1.554-1.28-2.23-2.31-2.77-.69-.363-1.266-.664-1.256-1.13.008-.353.345-.73 1.08-.824a4.801 4.801 0 0 1 2.51.438l.447-2.088A6.84 6.84 0 0 0 26.498 11c-2.516 0-4.287 1.337-4.303 3.252-.016 1.416 1.265 2.207 2.229 2.678.992.483 1.324.792 1.321 1.224 0 .66-.792.95-1.524.962-1.242.019-1.978-.325-2.562-.597l-.051-.024-.461 2.156c.595.272 1.693.51 2.83.522 2.675 0 4.424-1.322 4.433-3.366l-.002.004zm-10.543-6.627l-4.124 9.84H11.05L9.02 13.17c-.124-.484-.23-.66-.606-.865-.61-.332-1.621-.643-2.511-.837l.06-.291h4.331a1.185 1.185 0 0 1 1.167 1.003l1.072 5.688 2.649-6.697 2.683.013zm19.543 9.831h-2.354l-.307-1.463H31.48l-.53 1.47h-2.674l3.82-9.118a1.16 1.16 0 0 1 1.083-.729h2.173l2.055 9.84zm-5.193-3.487l1.34-3.694.764 3.703-2.104-.009zM19.4 21.015l2.105-9.84h-2.549l-2.105 9.84H19.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B0B0B0",
    d: "M2.036 1C1.468 1 1 1.466 1 2.05v27.9c0 .584.468 1.05 1.036 1.05h39.928c.568 0 1.036-.466 1.036-1.05V2.05C43 1.466 42.532 1 41.964 1H2.036zM0 2.05C0 .922.907 0 2.036 0h39.928C43.093 0 44 .922 44 2.05v27.9c0 1.128-.907 2.05-2.036 2.05H2.036A2.043 2.043 0 0 1 0 29.95V2.05z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardVisa);
export default __webpack_public_path__ + "static/media/card-visa.c0e4fe50de58fb0f7e903eb5a1aaf8e2.svg";
export { ForwardRef as ReactComponent };